import { type SpecialType } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Flex, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";

export const SpecialDetail = ({ special }: { special: SpecialType }) => {
    const { isMobile, isLaptop } = MEDIA();

    const { imgList, special_idx, special_name, title, content } = { ...special };

    return (
        <Flex
            key={special_idx}
            as="section"
            columnGap="24px"
            position="relative"
            zIndex={3}
            flexDir={isMobile ? "column" : "row"}
        >
            <Flex
                maxW="1600px"
                w="100%"
                margin="0 auto"
                flexDir="column"
                padding={isMobile ? "0 16px" : "0 48px"}
                rowGap={isMobile ? "16px" : "24px"}
            >
                <Flex
                    flexDir="column"
                    marginBottom={isLaptop ? "0" : "8px"}
                    sx={{
                        "& p": {
                            fontFamily: "Noto Serif KR",
                            fontWeight: "140%",
                        },
                    }}
                >
                    <Text fontSize={isMobile ? "16px" : "24px"} color="#6b6b6b">
                        {special_name.kor}
                    </Text>
                    <Text fontSize={isMobile ? "20px" : "40px"}>{special_name.eng}</Text>
                </Flex>
                <Flex
                    w="100%"
                    flexDir={isMobile ? "column" : "row"}
                    columnGap={isMobile ? "0" : "48px"}
                    rowGap={isMobile ? "16px" : "0"}
                >
                    <Box
                        background={
                            imgList[0].img_URL ? `url(${imgList[0].img_URL})no-repeat center/cover` : "gray.100"
                        }
                        w={isMobile ? "100" : "55%"}
                        h={isMobile ? "296px" : "568px"}
                    />
                    <Flex w={isMobile ? "100" : "45%"} flexDir="column" rowGap={isMobile ? "32px" : "24px"}>
                        <Box minH="256px">
                            <Text>{title.kor}</Text>
                            <Text
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(content.kor.replace(/\r?\n/g, "<br />")),
                                }}
                            />
                        </Box>
                        <Flex w="100%" columnGap="24px">
                            {imgList.slice(1, 3).map((img) => (
                                <Box
                                    key={img.img_URL}
                                    background={img.img_URL ? `url(${img.img_URL})no-repeat center/cover` : "gray.100"}
                                    _first={{ width: isMobile ? "100%" : "50%", height: isMobile ? "224px" : "376px" }}
                                    _last={{
                                        display: isMobile ? "none" : "block",
                                        width: "50%",
                                        height: isMobile ? "224px" : "248px",
                                    }}
                                />
                            ))}
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
};
